import * as React from 'react';

function SvgIconChevron(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 23" {...props}>
      <path
        className="icon-chevron_svg__st0"
        d="M12.7 12.2c.4-.4.4-1.1 0-1.4L1.7.3C1.3-.1.7-.1.3.3s-.4 1 0 1.4l11 10.5v-1.4L.3 21.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l11-10.5z"
      />
    </svg>
  );
}

export default SvgIconChevron;
